import * as React from 'react';
import { useEffect, useState } from 'react';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { get_tags_list, get_mapped_tags_list, createNewTag, remove_tags_from_video, add_tags_to_video } from '../assets/constants/global_apis';
import { get_all_collections, get_mapped_collections_list, createNewCollection, remove_items_from_collection, add_videos_to_collection } from '../assets/constants/global_apis';
import { createFilterOptions } from '@mui/material/Autocomplete';
import { triggerAlert } from './AlertMessage';

const filter = createFilterOptions();

export const CustomizedTagSelector = (props) => {
  const [newElement, setNewelement] = useState('');
  let mappedElements = [], elementsList = [], setElementsList, setMappedElements, inputValue, setInputValue, videos, isViewOnly, vidPath,title;
  
  if (props?.elementsData?.isViewOnly == true) {
    
    isViewOnly = props.elementsData.isViewOnly;
    vidPath = props.elementsData.vidPath;
  } else {
    
    inputValue = props?.elementsData?.inputValue;
    setInputValue = props?.elementsData?.setInputValue;
    videos = props?.elementsData?.videos;
  }
  
  mappedElements = props?.elementsData?.mappedElements;
  elementsList = props?.elementsData?.elementsList;
  setElementsList = props?.elementsData?.setElementsList;
  setMappedElements = props?.elementsData?.setMappedElements;
  title=props?.elementsData?.title;

  let [elementsVewList, setElementsVewList] = useState(elementsList)
  let [mappedViewElements, setMappedViewElements] = useState(mappedElements)
  
  useEffect(() => {
    const fetchVideElementDetails = (path) => {
      
      if (props?.elementsData?.isViewOnly == true && elementsVewList?.length == 0 && setElementsList != undefined) {
        if(elementsList && elementsList?.length == 0){
          const getElementList= title=='Tags' ? get_tags_list : get_all_collections;
        getElementList().then((data) => {
          setElementsVewList(data);
        })}
        if (path != '' && mappedElements && mappedElements?.length == 0) {
          const getMappedList= title=='Tags' ? get_mapped_tags_list : get_mapped_collections_list;
          getMappedList(path).then((data1) => {
            setMappedViewElements(data1?.elements);
          }).catch(() => {
            setMappedViewElements([]);
          });
        }
      }
    }
    fetchVideElementDetails(vidPath);
  }, [])

  const videoElementMapping = (newElementName) => {
    let payload = [];
    title=='Tags' ? videos.map((item, index) => {
      payload.push({ ...item, label: newElementName })
    }) : videos.map((item, index) => {
      payload.push({ ...item, label: item.path.split("/").slice(-1)[0] });
    })
    return payload;
  }
  const addElementstoVideos = (element) => {
    if (element?.id && element?.label) {
      const addElementToVideo= title=='Tags' ? add_tags_to_video : add_videos_to_collection;
      addElementToVideo(element?.id,
        videoElementMapping(element?.label)).then(() => {
          triggerAlert("Success", `Videos added to ${element?.label} successfully`);
        })
    }
  }
  const addOnchangeHandler = (e, newvalue) => {
    const prelist = mappedElements, finalList = [], notavailableList = [];
    if (newvalue[newvalue.length - 1]?.label.includes("Add ")) {
      const labelsID = [];
      let newelement = newvalue[newvalue.length - 1]?.label?.replace("Add ", "");
      const creatElement= title=='Tags' ? createNewTag : createNewCollection;
      creatElement({
        label: newelement
      }).then((resp) => {
        const getElementList= title=='Tags' ? get_tags_list : get_all_collections;
        getElementList().then((elements) => {
          setElementsList(elements);
          addElementstoVideos(resp);
          let mappedElementsList = [prelist, resp]
          for (let i = 0; i < mappedElementsList.length; i++) {
            if (mappedElementsList[i]?.id && labelsID.indexOf(mappedElementsList[i]?.id) == -1 && !(mappedElementsList[i]?.label.includes('Add'))) {
              finalList.push(mappedElementsList[i]);
              labelsID.push(mappedElementsList[i].id);
            }
          }
          setMappedElements(finalList);
        })
      })

    }
    if (prelist?.length > newvalue?.length && prelist?.length != 0) {
      for (let i = 0; i < prelist.length; i++) {
        if (prelist[i]?.id && newvalue.indexOf(prelist[i]) !== -1 && !(prelist[i]?.label.includes('Add'))) {
          finalList.push(prelist[i]);
        }
        else if (newvalue.indexOf(prelist[i]) == -1) {
          notavailableList.push(prelist[i])
        }
      }
      if (notavailableList[0]?.id) {
        const removeElementFromVideo= title=='Tags' ? remove_tags_from_video : remove_items_from_collection;
        const removeVideos=videos.map((item) => {
          return { ...item, label: notavailableList[0]?.label }
        })
        removeElementFromVideo(notavailableList[0].id, removeVideos).then(() => {
          setMappedElements(finalList);
          console.log("Deleted " + props?.elementsData?.title);
        });
      }
    }
    else {
      const labelsID = [];
      for (let i = 0; i < newvalue.length; i++) {
        if (newvalue[i]?.id && labelsID?.indexOf(newvalue[i].id) == -1 && !(newvalue[i]?.label?.includes('Add'))) {
          finalList.push(newvalue[i]);
          labelsID.push(newvalue[i].id);
        }
        if (prelist.indexOf(newvalue[i]) == -1) {
          notavailableList.push(newvalue[i])
        }
      }
      addElementstoVideos(notavailableList[0]);
      setMappedElements(finalList);
    }
  }
  const handleCreateNewCollection = () => {
    if (newElement.trim() !== '') {
      const creatElement= title=='Tags' ? createNewTag : createNewCollection;
      creatElement({ label: newElement }).then((resp) => {
        setElementsList([...elementsList, resp]);
        setNewelement('');
        triggerAlert("Success",`New Collection ${resp.label} created successfully`);
      });
    }else{
      triggerAlert("Error", `Please enter a valid name for the new ${title.replace('s','')}.`);
    }
  }
  return (
    <Stack spacing={3} sx={{ width: 500 }}>
      <div className='d-flex justify-content-between align-items-center'>
        <input className='form-control' type="text" value={newElement} onChange={(e) => setNewelement(e.target.value)} placeholder={`Please Enter ${title.replace('s','')} Name`} />
        <button className='btn btn-primary' style={{width:'400px',marginLeft:'1rem'}} onClick={handleCreateNewCollection}>Create New {title.replace('s','')}</button>
      </div>
      {
        <Autocomplete
          multiple
          disablePortal ={props?.elementsData?.disablePortal==false ? props?.elementsData?.disablePortal : true}
          readOnly={isViewOnly ? isViewOnly : false}
          id="elements-standard"
          options={isViewOnly ? elementsVewList : elementsList}
          getOptionLabel={(element) => element.label}
          defaultValue={isViewOnly ? [...mappedViewElements] : [...mappedElements]}
          value={isViewOnly ? [...mappedViewElements] : [...mappedElements]}
          selectOnFocus={false}
          // filterSelectedOptions={true}
          onChange={(event, newValue) => {
            !isViewOnly && addOnchangeHandler(event, newValue)
          }}
          filterOptions={(options, params) => {
            const filtered = filter(options, params);

            const { inputValue } = params;
            // Suggest the creation of a new value
            const isExisting = options.some((option) => inputValue === option?.label);
            if (inputValue !== '' && !isExisting) {
              filtered.push({
                label: `Add ${inputValue}`,
              });
            }
            return filtered;
          }}

          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label={props?.elementsData?.title ? "Select "+ props.elementsData?.title : "Mapped Tags"}
              placeholder={props?.elementsData?.title  ? props?.elementsData?.title  : "Tags"}
            />
          )}
        />
      }
    </Stack>
  );
}

